<template>
  <v-container fluid fill-height justify-center id="scrolling-techniques-7" class="overflow-y-auto" key="bilerweather">
    <v-row class="max-w">
      <v-col cols="12">
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          class="mx-4"
        >
          <v-row>
            <v-col cols="3">
              <v-slider
                v-model="tempM20"
                :min="tempMin + 3"
                :max="tempMax"
                :error="this.tempM20Err"
                vertical
                color="secondary"
              >
                <template v-slot:append>
                  {{ sections[0] }}&deg;C
                </template>
              </v-slider>
              <div class="text-center mt-1">
                <v-btn class="ma-2" fab small color="secondary" @click="tempM20++">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
                <div>{{ tempM20 }}&deg;C</div>
                <v-btn class="ma-2" fab small color="secondary" @click="tempM20--">
                  <v-icon>mdi-minus</v-icon>
                </v-btn>
              </div>
            </v-col>
            <v-col cols="3">
              <v-slider
                v-model="tempM10"
                :min="tempMin + 2"
                :max="tempMax - 1"
                :error="this.tempM10Err"
                vertical
                color="secondary"
              >
                <template v-slot:append>
                  {{ sections[1] }}&deg;C
                </template>
              </v-slider>
              <div class="text-center mt-1">
                <v-btn class="ma-2" fab small color="secondary" @click="tempM10++">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
                <div>{{ tempM10 }}&deg;C</div>
                <v-btn class="ma-2" fab small color="secondary" @click="tempM10--">
                  <v-icon>mdi-minus</v-icon>
                </v-btn>
              </div>
            </v-col>
            <v-col cols="3">
              <v-slider
                v-model="temp0"
                :min="tempMin + 1"
                :max="tempMax - 2"
                :error="this.temp0Err"
                vertical
                color="secondary"
              >
                <template v-slot:append>
                  {{ sections[2] }}&deg;C
                </template>
              </v-slider>
              <div class="text-center mt-1">
                <v-btn class="ma-2" fab small color="secondary" @click="temp0++">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
                <div>{{ temp0 }}&deg;C</div>
                <v-btn class="ma-2" fab small color="secondary" @click="temp0--">
                  <v-icon>mdi-minus</v-icon>
                </v-btn>
              </div>
            </v-col>
            <v-col cols="3">
              <v-slider
                v-model="temp10"
                :min="tempMin"
                :max="tempMax - 3"
                :error="this.temp10Err"
                vertical
                color="secondary"
              >
                <template v-slot:append>
                  {{ sections[3] }}&deg;C
                </template>
              </v-slider>
              <div class="text-center mt-1">
                <v-btn class="ma-2" fab small color="secondary" @click="temp10++">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
                <div>{{ temp10 }}&deg;C</div>
                <v-btn class="ma-2" fab small color="secondary" @click="temp10--">
                  <v-icon>mdi-minus</v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>

          <div class="d-flex mt-5 t-primary justify-center">
            <v-btn 
              :loading="saving"
              :disabled="saving || loading" 
              @click="postForm"
              x-large 
              class="mx-1" 
              color="primary"
              >{{ $t('zapisz') }}</v-btn>
              <v-btn x-large text class="mx-1" @click="$router.go(-1)">{{ $t('anuluj') }}</v-btn>
          </div>
        </v-form>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import _ from 'lodash'
export default {
  data: () => ({
    sections: [-20, -10, 0, 10],
    valid: true,
    tempM20: 0,
    tempM10: 0,
    temp0: 0,
    temp10: 0,
    tempM20Err: false,
    tempM10Err: false,
    temp0Err: false,
    temp10Err: false
  }),
  computed: {
    controllerId() {
      return this.$route.params.controllerId;
    },
    moduleName() {
      return 'c' + this.controllerId;
    },
    params () {
      return (this.$store.state[this.moduleName]) ? this.$store.state[this.moduleName].params : undefined
    },
    tempMin() {
      return (this.$store.state[this.moduleName]) ? this.$store.state[this.moduleName].boilerTempMin : undefined
    },
    tempMax() {
      return (this.$store.state[this.moduleName]) ? this.$store.state[this.moduleName].boilerTempMax : undefined
    },
    saving() {
      if (this.$store.state[this.moduleName] !== undefined) {
        return this.$store.state[this.moduleName].saving
      } else {
        return true
      }
    },
    loading() {
      if (this.$store.state[this.moduleName] !== undefined) {
        return this.$store.state[this.moduleName].loading
      } else {
        return true
      }
    },
    /*rulesM20() {
      return [
      (v) => {
        if (v > this.tempM10) {
          return true;
        } else {
          return 'err';
        }
      }
    ]},*/
  },
  watch: {
    tempM20: 'valTempM20',
    tempM10: 'valTempM10',
    temp0: 'valTemp0',
    temp10: 'valTemp10',
  },
  created () {
    //przekieruj na dashboard jesli wejscie bezposrednie, a moze lepiej zarejestrowac modul i zsynchronizowac dane?
    if (!(this.$store && this.$store.state && this.$store.state[this.moduleName])) {
      this.$router.push({ path: '/dashboard/' + this.controllerId });
    } else {
      this.getWeather(true)
      .then(res => {
        this.tempM20 = res.tempM20;
        this.tempM10 = res.tempM10;
        this.temp0 = res.temp0;
        this.temp10 = res.temp10;
      });
    };
  },
  methods: {
    valTempM20: _.debounce(function () {
      this.tempM20Err = this.tempM20 <= this.tempM10 
    }, 300),
    valTempM10: _.debounce(function () {
      this.tempM10Err = this.tempM10 >= this.tempM20 || this.tempM10 <= this.temp0
    }, 300),
    valTemp0: _.debounce(function () {
      this.temp0Err = this.temp0 >= this.tempM10 || this.temp0 <= this.temp10
    }, 300),
    valTemp10: _.debounce(function () {
      this.temp10Err = this.temp10 >= this.temp0
    }, 300),
    getWeather(forced) {
      return this.$store.dispatch(`${this.moduleName}/getBoilerWeather`, forced)
    },
    postForm () {
      if (this.tempM20Err || this.tempM10Err || this.temp0Err || this.temp10Err) {
        this.$store.commit("alert", {
          color: "error",
          text: 'zla-krzywa'
        });
      } else {
        this.$store.dispatch(`${this.moduleName}/setBoilerWeather`, { 
          tempM20: this.tempM20, 
          tempM10: this.tempM10,
          temp0: this.temp0,
          temp10: this.temp10,
        }).then(res => {
          if (res.error) {
            this.$store.commit("alert", {
              color: "error",
              text: res.error.code
            });
          } else {
            this.$store.commit("alert", {
              color: "success",
              timeout: 900,
              ok: true,
              text: 'OK'
            });
            this.$router.push({ path: '/dashboard/' + this.controllerId });
          }
        });
      }
    }
  },
}
/*elementYouWantToScroll.ontouchmove = function(e) {
    e.stopPropagation();
}; 
document.ontouchmove = function(e) {
    var target = e.currentTarget;
    while(target) {
        if(checkIfElementShouldScroll(target))
            return;
        target = target.parentNode;
    }

    e.preventDefault();
};*/
</script>

<style>

</style>

